import React, { useEffect, useState, Text } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useHistory,
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { setCidade, getIdCidadeEcrie, getTotem } from '../../api/apiFactory';
import { fetchLimparCookie, fetchNomeCidade, fetchEvento } from '../../api/endpoints';
import { definirCidade, fetchConfiguracoesCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao } from '../../app/slices/loginSlice';
import { resetarModais, selectModal } from '../../app/slices/modalSlice';
import imagemNaoDisponivel from '../../assets/images/imagemindisponivel.png';
import AppHeader from '../../components/AppHeader/AppHeader';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import Carregar from '../../components/Carregar/Carregar';
import Botao from '../../components/Botao/Botao';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import { espacamento } from '../../styles/constants/sizes';
import {
  AppBody, AppFragment, BreadCumbs, Container, Grid, Interno, Linha, Titulo,
} from '../../styles/base';

const IniciarEventoTotem = () => {
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);
  const [evento, setEvento] = useState();

  const dispatch = useDispatch();
  const history = useHistory();
  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  if (cookieId) {
    const escolherCidadeCookie = async (Id, Campo) => {
      setCidade({ Id, Campo });
      dispatch(definirCidade({
        idCidade: Id,
        nomeCidade: Campo,
      }));
      await fetchLimparCookie();
      await dispatch(fetchConfiguracoesCidade());
    };

    dispatch(desfazerConexao());
    fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
  }

  const { id } = useParams();

  useEffect(() => {
    fetchEvento(parseFloat(id)).then((response) => { setEvento(response); });
    if (!(getIdCidadeEcrie() > 0)) {
      history.push('/');
    }
  }, []);

  if (!evento) {
    return (
      <Carregar />
    );
  }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      <Botao
        voltar
        label="Voltar"
        style={{
          marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
        }}
        onClick={() => history.push('/totem/eventos')}
      />
      <AppBody totem desfoque={dadosModal.desfoque}>
        <BreadCumbs>
          Você está em:
          {' '}
          <span style={{ fontWeight: 'bold' }}>Serviços</span>
          {' '}
          <span>&rsaquo;</span>
          {' '}
          <span style={{ fontWeight: 'bold' }}>Eventos</span>
        </BreadCumbs>
        <Container style={{ marginTop: 180 }} totem>
          <Interno>
            <Linha>
              <div>
                <h2>{evento.Titulo}</h2>
                <p>
                  Publicado em:
                  {' '}
                  {evento.DataHoraEvento}
                </p>
                {evento.FotoCapa && (<div style={{ margin: '0 auto', display: 'flex' }}><img src={evento.FotoCapa} style={{ width: '100%' }} alt="Foto de capa do evento" /></div>)}
                <p>
                  <Interno>
                    <div dangerouslySetInnerHTML={{ __html: evento.Html }} />
                  </Interno>
                </p>
              </div>
              {evento && evento.Message && evento.Message === 'Nenhum registro foi encontrado.' && (
              <p>Nenhum registro foi encontrado.</p>
              )}
            </Linha>
          </Interno>
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarEventoTotem;
